import {  ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RegionItem } from '@app/models/compass/RegionItem';
import { DynamicScriptLoaderService } from '@app/services/dynamicScriptLoader.service';
import { ExportService } from '@app/services/export.service';
declare var htmlToPdfmake;
interface Item {
    language: string;
    title: string;
    content: string;
    show: boolean;
}
interface Pass {
    destination: string;
    nationality: string;
    title: string;
    corona: Item;
    entry: Item;
    visa: Item;
    transit_visa: Item;
    health: Item;
    final_provisions: Item;
}

@Component({
    selector: 'app-ausamt',
    templateUrl: './ausamt.component.html',
    styleUrls: ['./ausamt.component.scss'],
    standalone: false
})
export class AusamtComponent implements OnChanges {
    @Input() currentRegionData: RegionItem;
    @Input() passolutionData: Pass;
    @Input() deskmode: string;
    htmlToPdfmake: any;
    constructor(
        private cdr: ChangeDetectorRef,
        private exportService: ExportService,
        private dynamicScriptLoader: DynamicScriptLoaderService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['passolutionData']) {
            if (this.passolutionData?.corona?.content?.length > 0) {
                this.passolutionData.corona.content = this.convertContent(this.passolutionData.corona.content);
            }
            if (this.passolutionData?.entry?.content?.length > 0) {
                this.passolutionData.entry.content = this.convertContent(this.passolutionData.entry.content);
            }
            if (this.passolutionData?.health?.content?.length > 0) {
                this.passolutionData.health.content = this.convertContent(this.passolutionData.health.content);
            }
            if (this.passolutionData?.transit_visa?.content?.length > 0) {
                this.passolutionData.transit_visa.content = this.convertContent(this.passolutionData.transit_visa.content);
            }
            if (this.passolutionData?.visa?.content?.length > 0) {
                this.passolutionData.visa.content = this.convertContent(this.passolutionData.visa.content);
            }
            if (this.passolutionData?.final_provisions?.content?.length > 0) {
                this.passolutionData.final_provisions.content = this.convertContent(this.passolutionData.final_provisions.content);
            }

            this.cdr.markForCheck();
        }
    }

    convertContent(content: string): string {
        if (content?.length > 0) {
            content = content.replace(/<button/ig, '<button style="display:none" ')
                .replace(/<h4/gim, '<h4 style="margin: 1rem 0 0 0;font-weight: 400;" ')
                .replace(/<h3/gim, '<h3 style="margin: 1rem 0 0 0;font-weight: 400;" ')
                .replace(/<h2/gim, '<h2 style="margin: 1rem 0 0 0;font-weight: 400;" ')
                .replace(/<h1/gim, '<h1 style="margin: 1rem 0 0 0;font-weight: 500;font-size: 1.2rem;" ');
            content = content.replace(/<a[^>]*>(.*?)<\/a>/gim, '$1');
            const urlPattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
            content = content.replace(urlPattern, '<a href="$&" class="linkified" target="_blank">$&</a>');
            return content;
        } else {
            return null;
        }
    }

    exportPdf() {
        this.dynamicScriptLoader.load('html-to-pdfmake').then(data => {
            const content = [
                [
                    {
                        text: this.passolutionData?.title + ' - Quelle: Passolution',
                        fontSize: 16,
                        bold: false,
                        margin: [0, 0, 0, 20],
                        padding: 0
                    },
                ]
            ];

            if (this.passolutionData.corona?.content?.length > 0) {
                content.push([
                    {
                        table: {
                            widths: ['100%'],
                            body: [
                                [
                                    {
                                        text: this.passolutionData.corona?.title,
                                        fontSize: 18,
                                        bold: true,
                                        margin: [0, 40, 10, 10],
                                        padding: 0,
                                        border: [false, false, false, true],
                                    },
                                ],
                            ],
                        },
                        margin: [0, 0, 0, 30],
                    },
                    this.getCOntentForPdf(this.passolutionData.corona.content)

                ]
                );
            }
            if (this.passolutionData.entry?.content?.length > 0) {
                content.push(
                    [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            text: this.passolutionData.entry?.title,
                                            fontSize: 18,
                                            bold: true,
                                            margin: [0, 40, 10, 10],
                                            padding: 0,
                                            border: [false, false, false, true],
                                        },
                                    ],
                                ],
                            },
                            margin: [0, 0, 0, 30],
                        },
                        this.getCOntentForPdf(this.passolutionData.entry.content)
                    ]
                );
            }
            if (this.passolutionData.visa?.content?.length > 0) {
                content.push(
                    [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            text: this.passolutionData.visa?.title,
                                            fontSize: 18,
                                            bold: true,
                                            margin: [0, 40, 10, 10],
                                            padding: 0,
                                            border: [false, false, false, true],
                                        },
                                    ],
                                ],
                            },
                            margin: [0, 0, 0, 30],
                        },
                        this.getCOntentForPdf(this.passolutionData.visa.content)
                    ]
                );
            }
            if (this.passolutionData.transit_visa?.content?.length > 0) {
                content.push(
                    [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            text: this.passolutionData.transit_visa?.title,
                                            fontSize: 18,
                                            bold: true,
                                            margin: [0, 40, 10, 10],
                                            padding: 0,
                                            border: [false, false, false, true],
                                        },
                                    ],
                                ],
                            },
                            margin: [0, 0, 0, 30],
                        },
                        this.getCOntentForPdf(this.passolutionData.transit_visa.content)
                    ]
                );
            }
            if (this.passolutionData.health?.content?.length > 0) {
                content.push(
                    [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            text: this.passolutionData.health?.title,
                                            fontSize: 18,
                                            bold: true,
                                            margin: [0, 40, 10, 10],
                                            padding: 0,
                                            border: [false, false, false, true],
                                        },
                                    ],
                                ],
                            },
                            margin: [0, 0, 0, 30],
                        },
                        this.getCOntentForPdf(this.passolutionData.health.content)
                    ]
                );
            }
            if (this.passolutionData.final_provisions?.content?.length > 0) {
                content.push(
                    [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            text: this.passolutionData.final_provisions?.title,
                                            fontSize: 18,
                                            bold: true,
                                            margin: [0, 40, 10, 10],
                                            padding: 0,
                                            border: [false, false, false, true],
                                        },
                                    ],
                                ],
                            },
                            margin: [0, 0, 0, 30],
                        },
                        this.getCOntentForPdf(this.passolutionData.final_provisions.content)
                    ]
                );
            }

            this.exportService.exportReisekompass(content);
        }).catch(error => console.log(error));
    }

    getCOntentForPdf(content): any {
        if (content?.length > 0) {
            const tmp_cont = content
                .replace(/<div class="heading">/gim, '<div style="font-size: 1.2rem;border-bottom: none;color: #3973b9;margin:10px;">')
                .replace(/<div class="condition_headline">/gim, '<div style="font-size: 1.4rem;margin-bottom: 10px;">')
                .replace(/<div class="col-md-6 col-lg-4">/gim, '<div style="margin-top:50px;">')
                .replace(/<div class="condition_types">/gim, '<div style="font-size: 1.2rem;font-weight: 600;margin-bottom: 5px;">');
            const topdf = htmlToPdfmake(tmp_cont);
            return topdf;
        } else {
            return ''
        }
    }
}
